import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enCommon from '@/locales/en/common.json';
import esCommon from '@/locales/es/common.json';
import enAdmin from '@/locales/en/admin.json';
import esAdmin from '@/locales/es/admin.json';
import enEcommerce from '@/locales/en/ecommerce.json';
import esEcommerce from '@/locales/es/ecommerce.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        admin: enAdmin,
        ecommerce: enEcommerce,
      },
      es: {
        common: esCommon,
        admin: esAdmin,
        ecommerce: esEcommerce,
      },
    },
    // Spanish as fallback - most users are from Latin America
    fallbackLng: 'es',
    defaultNS: 'common',
    ns: ['common', 'admin', 'ecommerce'],
    interpolation: {
      escapeValue: false,
    },
    // Language detection configuration
    detection: {
      // Order of detection methods (localStorage first to respect user preference)
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache user language preference in localStorage
      caches: ['localStorage'],
      // Key to use in localStorage
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
